import { Space, Spin, Typography } from 'antd'
import { CIMSPage, FilenameTemplate } from '@cims-online/shared'
import { WarningsProps } from './types'
import { useFilenamesWarningsQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import ProjectLink from 'components/ProjectLink'
import { useProjectContext } from 'context/ProjectContext'

const Warnings: React.FC<WarningsProps> = ({ preface, children, style }) => {
  const { projectId } = useProjectContext()
  const { data, loading } = useFilenamesWarningsQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId },
  })
  return (
    <Spin spinning={loading ?? false}>
      <Space direction="vertical" style={style}>
        {preface}
        <Typography.Text>
          If the value associated with any Template Item is unset, it will be
          skipped.
        </Typography.Text>
        {
          <Typography.Text>
            Spaces{' '}
            {data?.projectMetadata?.replaceSpacesWithDashesInFilenames
              ? 'are'
              : 'can be'}{' '}
            <ProjectLink item={CIMSPage.ProjectSettings}>replaced</ProjectLink>{' '}
            with dashes.
          </Typography.Text>
        }
        <Typography.Text>
          If found in any value, these illegal characters will be skipped:{' '}
          <Typography.Text code>
            {FilenameTemplate.illegal.characters.join(' ')}
          </Typography.Text>
        </Typography.Text>
        {children}
      </Space>
    </Spin>
  )
}

export default Warnings
